import React, { useState, useMemo } from "react";
import ServerDataGrid from "../../../../views/pages/manage/common/data-grid/ServerDataGrid";
// --- Import your new Grid ---
import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";
import { approvalConfig } from "../shared/config";


const ListComponent = ({
    getApprovalRequests,
    rows,
    updateStatus,
    isApprovePermission,
    paginationInfo,
    setLoader,
    dropdowns,
    setUpdateStatusInfo,
    userDetails,
    onViewSlip,
    type,
    getChequeDateExtensionLogs,
    showModelInfo,
    setShowModelInfo

}) => {
    const [buDescriptionMap, setBuDescriptionMap] = useState();
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const navigateToGivenPath = useNavigateToGivenPath();

    // --- Column Definitions (Converted for ServerDataGrid) ---
    const columns = useMemo(() => {
        return approvalConfig[type].columns({
            dropdowns,
            userDetails,
            updateStatus,
            setUpdateStatusInfo,
            onViewSlip,
            isApprovePermission,
            setLoader,
            navigateToGivenPath,
            buDescriptionMap,
            setBuDescriptionMap,
            getChequeDateExtensionLogs,
            showModelInfo,
            setShowModelInfo,
        });
    }, [
        type,
        dropdowns,
        userDetails,
        updateStatus,
        setUpdateStatusInfo,
        onViewSlip,
        isApprovePermission,
        setLoader,
        navigateToGivenPath,
        getChequeDateExtensionLogs,
        showModelInfo,
        setShowModelInfo,
    ]);

    // --- Map Pagination Info ---
    const pagination = {
        page: (paginationInfo?.currPageNo ?? 0) + 1,
        pageSize: paginationInfo?.currPageSize || 10,
        total: paginationInfo?.totalRecords || 0,
        totalPages: paginationInfo?.totalPage || 0
    };


    // --- Handlers ---
    const handlePageChange = (newPage) => {
        const offset = newPage - 1; 

        getApprovalRequests({
            pageNo: offset,
            pageSize: pagination.pageSize
        });
    };

    const handlePageSizeChange = (newSize) => {
        getApprovalRequests({ pageNo: 0, pageSize: newSize });
    };
    return (<>
        <ServerDataGrid
            rows={rows || []}
            loading={false} // Loading handled by ALoader above, so we don't double spin

            // Configuration
            columns={columns}
            rowKey="id" // Assuming your data has an 'id' field. If not, pass a function or unique key.

            // Pagination
            pagination={pagination}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}

            // Selection
            // selectable={checkboxHandler()}
            // selectedIds={selectedIds}
            // onSelectionChange={handleSelectionChange}

            // Sorting (Optional: Pass onSortChange if you have a handler for it)
            sortConfig={sortConfig}
            onSortChange={(key, direction) => setSortConfig({ key, direction })}
        />
    </>
    )
}
export default ListComponent